import {Button, Card, Subtitle2, Text} from "@fluentui/react-components";

function SettingsItem({title, text, buttonText, onClick, buttonColor = null, buttonAppearance = "outline"}){
    return (
        <Card
            className={`card card-horizontal`}
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center"
            }}>
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
            }}>
                <Subtitle2>{title}</Subtitle2>
                <Text>{text}</Text>
            </div>
            <Button as={"a"} className={`button`} appearance={buttonAppearance} onClick={onClick} style={{ color: buttonColor, borderColor: buttonColor }}>
                {buttonText}
            </Button>
        </Card>
    )
}

export default SettingsItem;